import { createSlice } from "@reduxjs/toolkit";

import {
    getAllDestinationsRedux,
    getDestinationForAddingTrackers,
} from "./destinations.asyncActions";

const initialState = {
    getAllDestinations: {
        message: "",
        status: "idle",
        destinations: [],
        statusforAddingTrackers: "idle",
        destinationsForAddingTracker: [],
    },
};

export const destinationsSlice = createSlice({
    name: "allDestinationsState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllDestinationsRedux.pending, (state) => {
                state.getAllDestinations.status = "loading";
            })
            .addCase(getAllDestinationsRedux.fulfilled, (state, action) => {
                state.getAllDestinations.status = "success";
                state.getAllDestinations.destinations =
                    action.payload.data && action.payload.data;
            })
            .addCase(getAllDestinationsRedux.rejected, (state, action) => {
                state.getAllDestinations.status = "failed";
                state.getAllDestinations.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getDestinationForAddingTrackers.pending, (state) => {
                state.getAllDestinations.statusforAddingTrackers = "loading";
            })
            .addCase(
                getDestinationForAddingTrackers.fulfilled,
                (state, action) => {
                    state.getAllDestinations.statusforAddingTrackers =
                        "success";
                    state.getAllDestinations.destinationsForAddingTracker =
                        action.payload.data && action.payload.data;
                },
            )
            .addCase(
                getDestinationForAddingTrackers.rejected,
                (state, action) => {
                    state.getAllDestinations.statusforAddingTrackers = "failed";
                },
            );
    },
});

export default destinationsSlice.reducer;
